const ClonedIcon = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M8 1H3C2.44772 1 2 1.44772 2 2V7'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinecap='round'
    />
    <rect x='4' y='4' width='7' height='7' rx='1' stroke='currentColor' strokeWidth='1.5' />
  </svg>
)

export default ClonedIcon
